<!--
 * @Author: Shber
 * @Date: 2023-05-18 18:27:35
 * @LastEditors: Shber
 * @LastEditTime: 2023-05-19 11:01:30
 * @Description:
-->
<template>
  <div v-if="isShow" class="mc_skeleton">
    <van-skeleton
      class="skeleton_pic"
      :avatar-size="375"
      :avatar="true"
      avatar-shape="square"
      :row="0"
      :loading="true"
    />
    <van-skeleton
      class="mt30"
      title
      :row="6"
      :loading="true"
    />

  </div>

</template>
<script setup>
import { defineEmits, defineProps } from 'vue'
import { Skeleton as VanSkeleton } from 'vant'

const emits = defineEmits(['onFinish'])
const props = defineProps({
  isShow: {
    type: Boolean,
    default: true
  }
})

</script>
<style lang="scss" scoped>
.mc_skeleton{
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 99;
  background: #fff;
  .skeleton_pic{ padding: 0; }
  &:deep(.van-skeleton__avatar--square){width: 375px !important; margin: 0;}
}
</style>
